import React, { Component } from 'react'

import downwardArrowImage from '../../Images/lenderimages/faqDownArrow.svg';
import rightArrowImage from '../../Images/lenderimages/faqRightArrow.svg';

const faqHeadingStyle = {
    background: 'linear-gradient(91deg, #1A54AB 0%, #28B6BF 103.91%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
    fontFamily: 'Arial',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '32px',
    textTransform: 'capitalize',
}

const faqQuestionStyle = {
    color: '#091E42',
    fontFamily: 'Arial',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '49px',
    marginRight:'20px',
    textAlign:'justify',
}

const borderLine={
    borderTop: '1px solid rgba(9, 30, 66, 0.70)',
    height: '1px',
    opacity: '0.5',
}

const faqClickableDiv={
    cursor: 'pointer', 
    display: 'flex', 
    alignItems: 'center' 
}

const answerListStyle={
    marginRight:'40px',
    textAlign:'justify',
    color: '#091E42',
  fontFamily: 'Arial',
  fontSize: '17px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '30px',
}

export class LoanTapFAQsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAnswer1: false,
            showAnswer2: false,
            showAnswer3: false,
            showAnswer4: false,
            showAnswer5: false,
        };
        this.resetStates = this.resetStates.bind(this);
    }

    resetStates() {
        this.setState({
            showAnswer1: false,
            showAnswer2: false,
            showAnswer3: false,
            showAnswer4: false,
            showAnswer5: false,
        });
    }

    handleClick = (number) => {
        this.resetStates();
        if(number === '1'){
            this.setState({showAnswer1:!this.state.showAnswer1});
        }
        else if(number === '2'){
            this.setState({showAnswer2:!this.state.showAnswer2});
        }
        else if(number === '3'){
            this.setState({showAnswer3:!this.state.showAnswer3});
        }
        else if(number === '4'){
            this.setState({showAnswer4:!this.state.showAnswer4});
        }
        else if(number === '5'){
            this.setState({showAnswer5:!this.state.showAnswer5});
        }

    }

    render() {
        return (
            <>
                <section>
                    <div style={{ margin:'100px' }}>
                        <div style={{ ...faqHeadingStyle }}>Frequently Asked Questions</div>
                        <div className='container' style={{ padding: '0px', marginTop: '32px' }}>
                        <div className='row' style={{ marginTop: '24px' }}>
                                <div className='col-12'>
                                    <div style={{ marginTop: '24px' }}>
                                        <div onClick={() => this.handleClick('1')} style={faqClickableDiv}>
                                            <div style={{ ...faqQuestionStyle}}>What is a Business Loan?</div>
                                            {this.state.showAnswer1 ? (
                                                <img src={downwardArrowImage} alt="downward arrow" style={{ marginLeft: 'auto' }} />
                                            ) : (
                                                <img src={rightArrowImage} alt="right arrow" style={{ marginLeft: 'auto' }} />
                                            )}
                                        </div>
                                        {this.state.showAnswer1 &&
                                            <div style={{marginTop:'10px'}}>
                                                <ul>
                                                    <li style={answerListStyle}>LoanTap’s business loan is an unsecured loan for small to medium-scale businesses. It is designed with the aim of making credit more accessible, affordable, and convenient for them. Businesses can avail of a loan for any purpose, i.e., upgrading machinery, investing in inventory, or maintaining cash flow for day-to-day operations.</li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='row' style={{ marginTop: '24px' }}>
                                <div className='col-12'>
                                    <div style={borderLine}></div>
                                    <div style={{ marginTop: '24px' }}>
                                        <div onClick={() => this.handleClick('2')} style={faqClickableDiv}>
                                            <div style={{ ...faqQuestionStyle}}> What is the minimum and maximum loan amount?</div>
                                            {this.state.showAnswer2 ? (
                                                <img src={downwardArrowImage} alt="downward arrow" style={{ marginLeft: 'auto' }} />
                                            ) : (
                                                <img src={rightArrowImage} alt="right arrow" style={{ marginLeft: 'auto' }} />
                                            )}
                                        </div>
                                        {this.state.showAnswer2 &&
                                            <div style={{marginTop:'10px'}}>
                                                <ul>
                                                    <li style={answerListStyle}>LoanTap offers business loans between ₹50,000 to ₹10,00,000. The final loan amount will be decided based on your eligibility and credit checks.</li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='row' style={{ marginTop: '24px' }}>
                                <div className='col-12'>
                                    <div style={borderLine}></div>
                                    <div style={{ marginTop: '24px' }}>
                                        <div onClick={() => this.handleClick('3')} style={faqClickableDiv}>
                                            <div style={{ ...faqQuestionStyle}}> Is LoanTap’s Business loan available in my city?</div>
                                            {this.state.showAnswer3 ? (
                                                <img src={downwardArrowImage} alt="downward arrow" style={{ marginLeft: 'auto' }} />
                                            ) : (
                                                <img src={rightArrowImage} alt="right arrow" style={{ marginLeft: 'auto' }} />
                                            )}
                                        </div>
                                        {this.state.showAnswer3 &&
                                            <div>
                                                <ul style={{marginTop:'10px'}}>
                                                    <li style={answerListStyle}>LoanTap offers their business loans in the following cities - Delhi-NCR, Pune, Nashik, Nagpur, Bangalore, Mumbai, Lucknow, Chennai, Tirupati, Ahmedabad, Indore, Bhopal, Amaravati, Coimbatore, Ghaziabad, Noida, Thane, Mumbai suburban, Gurugram, Ujjain, Faridabad, Navi Mumbai, Trichy, Kochin.</li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='row' style={{ marginTop: '24px' }}>
                                <div className='col-12'>
                                <div style={borderLine}></div>
                                    <div style={{ marginTop: '24px' }}>
                                        <div onClick={() => this.handleClick('4')} style={faqClickableDiv}>
                                            <span style={faqQuestionStyle}>Can I make higher payments towards my outstanding loan? Will I have to bear charges for the same?</span>
                                            {this.state.showAnswer4 ? (
                                                <img src={downwardArrowImage} alt="downward arrow" style={{ marginLeft: 'auto' }} />
                                            ) : (
                                                <img src={rightArrowImage} alt="right arrow" style={{ marginLeft: 'auto' }} />
                                            )}
                                        </div>
                                        {this.state.showAnswer4 &&
                                            <div>
                                                <ul style={{marginTop:'10px'}}>
                                                    <li style={answerListStyle}>Yes. You can make higher payments towards your outstanding loan. There will be no charges applicable on the same post 6 months of loan disbursement. You can make higher payments or foreclose your loan within 6 months with minimal charges.</li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='row' style={{ marginTop: '24px' }}>
                                <div className='col-12'>
                                <div style={borderLine}></div>
                                    <div style={{ marginTop: '24px' }}>
                                        <div onClick={() => this.handleClick('5')} style={faqClickableDiv}>
                                            <span style={faqQuestionStyle}> How long will it take for the business loan to be disbursed?</span>
                                            {this.state.showAnswer5 ? (
                                                <img src={downwardArrowImage} alt="downward arrow" style={{ marginLeft: 'auto' }} />
                                            ) : (
                                                <img src={rightArrowImage} alt="right arrow" style={{ marginLeft: 'auto' }} />
                                            )}
                                        </div>
                                        {this.state.showAnswer5 &&
                                            <div>
                                                <ul style={{marginTop:'10px'}}>
                                                    <li style={answerListStyle}>LoanTap has a quick and efficient underwriting system which ensures that your loans are disbursed within 24 hours to 36 working hours; provided all documentation and credit checks are in place.</li>
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='row' style={{ marginTop: '24px' }}>
                                <div className='col-12'>
                                    <div style={borderLine}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

export default LoanTapFAQsComponent